<template lang="html">

    <div>


        <div class="contenedor-botones row-start">

            <button class="btn -solid-primary" @click="aceptar">Aceptar inscripción</button>
            <button class="btn -skull-primary" @click="showrechazar= true">Rechazar inscripción</button>

        </div>


    <div class="cover-popup -middle row-center" v-if="showrechazar">

        <div class="popup">
  
          <a @click="showrechazar= false" class="close">✕</a>
  
          <h2 class="title-pop">Motivos del rechazo</h2>
  
          <div class="contenedor-input">
            <select v-model="idMotivo" v-validate="'required'" name="estado">
              <option value="">- Selecciona un motivo de rechazo -</option>
              <template v-for="(motivo, key) in motivos">
                <option v-if="motivo.idEstado == 17" :value="motivo.idMotivo">{{motivo.descripcion}}</option>
              </template>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('estado')}}</span>
          </div>
  
  
          <button class="btn -solid-primary" @click="rechazar">Rechazar preinscripción</button>
  
        </div>
      </div>

      <popup-confirmacion-preinscripcion v-if="popupDocVisible" :id="url" @cerrarPopup="popupDocVisible= false;dataPopupDoc=null;" :documentosPendientes="dataPopupDoc.documentacionNecesaria"
        @toggleInscrito="aceptar" @tieneDocumentacionFirmablePendiente="mostrarDocFirmablePendiente" ></popup-confirmacion-preinscripcion>

      <popup-documentacion-firmable v-if="popupFirmarDocVisible" @cerrarPopup="popupFirmarDocVisible=false;dataPopupFirmarDoc=null;" 
        :documentosPendientesFirma="dataPopupFirmarDoc" :empresa="false"></popup-documentacion-firmable>


    </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex'

    import VeeValidate from 'vee-validate';

    import arrowLink from '@/components/parts/icons/arrow-link';

    
    import popupconfirmacion from '@/components/views/ofertas/popup-confirmacion-preinscripcion'
    import popupDocumentacionFirmable from '@/components/views/documentacion/popup-documentacion-firmable';
  
    export default  {
      name: 'candidatura-options',
      props : ['url','type','idEstado','documentacionPendienteFirma'],
      data(){
          return{
            showrechazar : false,
            idMotivo : '',
            clicked : false,
            popupDocVisible: false,
            dataPopupDoc: null,
            popupFirmarDocVisible: false,
            dataPopupFirmarDoc: null
          }
      },
      computed: {
        ...mapGetters({
          style : 'getStyles',
          motivos : 'getmotivosRechazo'
        })
      },  
        methods : {
            ...mapActions(['aceptarPreinscripcion','rechazarPreinscripcion']),
            aceptar(){
                let data = {"urlOferta" : this.url}
                this.popupDocVisible = false;
                this.dataPopupDoc = null;
                this.popupFirmarDocVisible = false;
                this.dataPopupFirmarDoc = null;
                this.aceptarPreinscripcion(data).then( r => {
                  if(r.data.status == 11){
                    //faltan documentos
                    this.popupDocVisible = true;
                    this.dataPopupDoc = r.data.datos;
                  }
                  if(r.data.status == 108){
                    //faltan documentos firmables
                    this.popupFirmarDocVisible = true;
                    this.dataPopupFirmarDoc = r.data.datos;
                  }
                });

            },
            mostrarDocFirmablePendiente: function (doc) {
              console.log(doc)
              this.popupFirmarDocVisible = true;
              this.dataPopupFirmarDoc = doc;
            },
            rechazar(){
                this.clicked = true;
                this.$validator.validateAll().then(itsOk => {
                    if (itsOk) {

                    let data = {
                        "urlOferta" : this.url,
                        'idMotivo' : this.idMotivo
                    };
            
                    this.rechazarPreinscripcion(data).then( r => {
                        this.showrechazar = false;
                    });

                    }
                });

            }
      },
      components :{
        'arrow-link': arrowLink,
        'popup-confirmacion-preinscripcion': popupconfirmacion,
        'popup-documentacion-firmable': popupDocumentacionFirmable
      }
    }
  </script>
<style scoped lang="scss">


.contenedor-botones{
  margin-top: 15px;
  position: relative;
  z-index: 6;
  width: 100%;
}

.btn{
  margin-right: 10px;
  margin-bottom: 10px;
}

  
  </style>


// WEBPACK FOOTER //
// src/components/views/ofertas/candidatura-options.vue